/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ErrorResp, GetItemCountV3Params, GetItemCountV4Params, ItemCounts } from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Item Counts
 */
export const getItemCountV3 = (
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountV3Params,
  signal?: AbortSignal,
) => {
  return customInstance<ItemCounts>({
    url: `/BboMockTransactionApiService/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/itemCount`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetItemCountV3QueryKey = (
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountV3Params,
) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/itemCount`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetItemCountV3QueryOptions = <
  TData = Awaited<ReturnType<typeof getItemCountV3>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountV3Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemCountV3>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetItemCountV3QueryKey(branch, from, to, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemCountV3>>> = ({ signal }) =>
    getItemCountV3(branch, from, to, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(branch && from && to),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getItemCountV3>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetItemCountV3QueryResult = NonNullable<Awaited<ReturnType<typeof getItemCountV3>>>;
export type GetItemCountV3QueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Item Counts
 */
export const useGetItemCountV3 = <
  TData = Awaited<ReturnType<typeof getItemCountV3>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetItemCountV3Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemCountV3>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetItemCountV3QueryOptions(branch, from, to, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Item Counts
 */
export const getItemCountV4 = (
  branch: string,
  params: GetItemCountV4Params,
  signal?: AbortSignal,
) => {
  return customInstance<ItemCounts>({
    url: `/BboMockTransactionApiService/transactionviewer/v4/branch/${branch}/itemCounts`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetItemCountV4QueryKey = (branch: string, params: GetItemCountV4Params) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v4/branch/${branch}/itemCounts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetItemCountV4QueryOptions = <
  TData = Awaited<ReturnType<typeof getItemCountV4>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  params: GetItemCountV4Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemCountV4>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetItemCountV4QueryKey(branch, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemCountV4>>> = ({ signal }) =>
    getItemCountV4(branch, params, signal);

  return { queryKey, queryFn, enabled: !!branch, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getItemCountV4>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetItemCountV4QueryResult = NonNullable<Awaited<ReturnType<typeof getItemCountV4>>>;
export type GetItemCountV4QueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Item Counts
 */
export const useGetItemCountV4 = <
  TData = Awaited<ReturnType<typeof getItemCountV4>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  params: GetItemCountV4Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemCountV4>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetItemCountV4QueryOptions(branch, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
